module.exports = __webpack_public_path__ + "img/ic_lock.ada3b071.svg";